
import { useEffect, useState } from 'react';
import { Table, useTheme, TableBody, Autocomplete, Box, InputAdornment, IconButton, TableCell, TableContainer, TableHead, TableRow, TextField, Checkbox, Typography, Tooltip, Button, } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import CustomTableContainer from '../../../components/table/CustomTableContainer';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
import useUserPermissions from '../../../components/user-permission/UserPermission';
import useRemarks from '../../../hooks/common/useRemarks';
import AddRemarks from '../../master/AddRemarks';

const ViewChildReelTable = ({ rowvalue, onRowsChange, ParentRollNumber, RefreshData, handleTransferReel }) => {
  const [rows, setRows] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const userPermissions = useUserPermissions();
  const [openAddRemark, setOpenAddRemark] = useState(false);


  // use hook
  // call load remarks
  const moduledetails = userPermissions.find(
    (m) =>
      m.module_name === "Winder Machine Production" &&
      m.parent_module_name === "Production"
  );

  const { remarkOptions, loadingRemarks,refetchRemarks } = useRemarks(moduledetails);  

  // Code implementation continues...
  const handleOpenAddRemark = () => setOpenAddRemark(true);

  const handleCloseAddRemark = () => {
    setOpenAddRemark(false);
    refetchRemarks();
  };

  useEffect(() => {
    if (rowvalue) {
      setRows(rowvalue.map(row => ({ ...row })));
    }
  }, [rowvalue]);


  const handleInputChange = async (index, columnName, value) => {

    let msg = "Kindly Change Child Roll reference number already exist,";
    let isvalid = false;

    if (columnName === 'cr_number_ref') {
      // validate child roll       
      let cr_number = value;

      if (cr_number !== '') {
        const para = {
          p_companyid: localStorage.getItem('companyid'),
          p_child_reel_number: cr_number
        };

        try {
          // Call API and wait for the response
          const data3 = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_VALIDATE_CHILD_ROLL_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);

          if (data3?.length > 0 && data3[0].cr_result === 'true') {
            // If the child roll exists, add the error message and reset value
            msg = msg + " " + data3[0].cr_number + ", ";
            isvalid = true;
            value = ''; // Reset the value

            // Update rows to reflect the change
            const newRows = [...rows];
            newRows[index][columnName] = value; // Reset cr_number_ref value to ''
            if (columnName === 'approved') {
              newRows[index].status = value ? 'approved' : 'booked';
            }
            setRows(newRows);
            onRowsChange(newRows);
          } else {
            // Check if the value already exists in any of the rows
            const isDuplicate = rows.some(row => row.cr_number_ref === cr_number);

            if (isDuplicate) {
              // If it is a duplicate, reset the value and show the message
              value = ''; // Reset the value
              msg = "Duplicate Child Roll reference number exists!";
              // Optionally, show a message or set an error state

              // Update rows to reflect the change
              const newRows = [...rows];
              newRows[index][columnName] = value; // Reset cr_number_ref value to ''
              if (columnName === 'approved') {
                newRows[index].status = value ? 'approved' : 'booked';
              }
              setRows(newRows);
              onRowsChange(newRows);
            } else {
              // If no duplicate, proceed with updating the rows normally
              const newRows = [...rows];
              newRows[index][columnName] = value;
              if (columnName === 'approved') {
                newRows[index].status = value ? 'approved' : 'booked';
              }
              setRows(newRows);
              onRowsChange(newRows);
            }
          }
        } catch (error) {
          // Optionally handle error
        }
      }
    }
    else {
      const newRows = [...rows];
      newRows[index][columnName] = value;
      if (columnName === 'approved') {
        newRows[index].status = value ? 'approved' : 'booked';
      }
      setRows(newRows);
      onRowsChange(newRows);
    }
  };


  const handleSelectAllClick = (event) => {
    const isChecked = event.target.checked; // Determine if the checkbox is checked

    // Update all rows based on the `isChecked` value
    const updatedRows = rows.map(row => ({
      ...row,
      approved: isChecked, // Update the checkbox value
      status: isChecked ? 'approved' : 'booked' // Update the status based on the checkbox
    }));

    setRows(updatedRows); // Update the state
    onRowsChange(updatedRows); // Notify parent or handle additional logic
  };


  const callReverseApproval = async (child_roll_number) => {

    const para = {
      p_companyid: 1,
      p_child_reel_number: child_roll_number,
    }

    await callApi(API_ENDPOINTS.PROD_MANAGEMENT_SET_REVERSE_APPROVAL, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          alert('Child roll number: ' + child_roll_number + ' approval has been reversed successfully.');
          const orderData = {
            p_companyid: 1,
            p_pr_number: ParentRollNumber,
            p_user_name: 'thiravidam',

          };

          // UPDATE PARENT ROLL STATUS
          const result = callApi(API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_PARENT_ROLL_STATUS, 'POST', { 'Content-Type': 'application/json' }, orderData);
          if (result) {
            // logical changes
            RefreshData();
          }

        }
      })
      .catch(error => {
        alert(error.message);
      });
  }







  return (
    <div>


      <CustomTableContainer colors={colors}>
        <TableContainer>
          <Table size="small">
            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
              <TableRow>
                {[
                  "Approved",
                  "CR NUMBER",
                  "REEL WIDTH",
                  "DESTINATION",
                  "CO NUMBER",
                  "GSM",
                  "QUALITY",
                  "PRODUCED QUANTITY",
                  "REMARKS",
                  "GRADE",
                  "RE-PULP QUANTITY",
                  "PARTY REMARKS",
                  "STATUS",
                  "Actions",
                ].map((header) => (
                  <TableCell key={header} style={{ padding: "1px", textAlign: "center" }}>
                    {header === "Approved" ? (
                      <Checkbox size="small" color="secondary" onChange={handleSelectAllClick} />
                    ) : (
                      header
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index} style={{ border: "1px solid black", fontSize: "12px" }}>
                  {/* Approved Checkbox */}
                  <TableCell align="center">
                    <Checkbox
                      color="secondary"
                      size="small"
                      checked={["approved", "wip", "rejected", "fg", "converted"].includes(row.status)}
                      onChange={(e) => handleInputChange(index, "approved", e.target.checked)}
                      disabled={["approved", "wip", "rejected", "fg", "converted"].includes(row.approved_status)}
                    />
                  </TableCell>

                  {/* Read-only or editable fields */}
                  {[
                    { field: "cr_number", editable: true, align: "center" },
                    { field: "master_reel", editable: false, align: "center" },
                    { field: "destination", editable: false, align: "center" },
                    { field: "indent_number", editable: false, align: "center" },
                    { field: "gsm", editable: false, align: "center" },
                    { field: "item_code", editable: false, align: "center" },
                    { field: "achieved_qty", editable: true, align: "right", type: "number", min: 0 },
                    // { field: "remarks", editable: true, align: "right", type: "text" },
                    { field: "remarks", editable: true, align: "center", isRemarksAutocomplete: true },
                    { field: "grade", editable: true, align: "center", isAutocomplete: true },
                    { field: "re_pulp_qty", editable: true, align: "right", type: "number", min: 0 },
                    { field: "party_remarks", editable: true, align: "center" },
                  ].map((col, idx) => (
                    <TableCell key={idx} align={col.align}>
                      {col.isAutocomplete ? (
                        <Autocomplete
                          size="small"
                          options={["G1", "SL", "Repulp", "BUFFER"]}
                          value={row[col.field] || ""}
                          onChange={(event, newValue) => handleInputChange(index, col.field, newValue)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              sx={{
                                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                "& .MuiInputBase-input": { padding: "4px" },
                              }}
                            />
                          )}
                        />
                      ) : col.isRemarksAutocomplete ? (
                        // ✅ Remarks autocomplete from API
                        // <Autocomplete
                        //   size="small"
                        //   options={remarkOptions.map((opt) => opt.remark_text)} // adjust field name if API returns differently
                        //   value={row[col.field] || ""}
                        //   onChange={(event, newValue) =>
                        //     handleInputChange(index, col.field, newValue)
                        //   }
                        //   loading={loadingRemarks}
                        //   renderInput={(params) => (
                        //     <TextField
                        //       {...params}
                        //       placeholder="Select remark"
                        //       variant="outlined"
                        //       sx={{
                        //         "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        //         "& .MuiInputBase-input": { padding: "4px" },
                        //       }}
                        //        InputProps={{
                        //         ...params.InputProps,
                        //         endAdornment: (
                        //           <Tooltip title="Add New Remarks">
                        //             <InputAdornment position="end">
                        //               <IconButton onClick={handleOpenAddRemark} size="small">
                        //                 <AddCircleOutlineIcon color="secondary" />
                        //               </IconButton>
                        //             </InputAdornment>
                        //           </Tooltip>
                        //         ),
                        //       }}

                        //     />
                        //   )}

                        // />

                        // <Autocomplete
                        //   size="small"
                        //   options={remarkOptions.map((opt) => opt.remark_text)} // adjust field name if API returns differently
                        //   value={row[col.field] || ""}
                        //   onChange={(event, newValue) =>
                        //     handleInputChange(index, col.field, newValue)
                        //   }
                        //   loading={loadingRemarks}
                        //   renderInput={(params) => (
                        //     <TextField
                        //       {...params}
                        //       placeholder="Select remark"
                        //       variant="outlined"
                        //       sx={{
                        //         "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        //         "& .MuiInputBase-input": { padding: "4px" },
                        //       }}
                        //       InputProps={{
                        //         ...params.InputProps,
                        //         endAdornment: (
                        //           <>
                        //             {/* keep Autocomplete's own adornments (loading icon, clear button, dropdown arrow) */}
                        //             {params.InputProps.endAdornment}

                        //             {/* custom icon */}
                        //             <InputAdornment position="end">
                        //               <Tooltip title="Add New Remark">
                        //                 <IconButton onClick={handleOpenAddRemark} size="small">
                        //                   <AddCircleOutlineIcon color="secondary" />
                        //                 </IconButton>
                        //               </Tooltip>
                        //             </InputAdornment>
                        //           </>
                        //         ),
                        //       }}
                        //     />
                        //   )}
                        // />

                        <Box display="flex" alignItems="center">
                          <Autocomplete
                            size="small"
                            options={remarkOptions.map((opt) => opt.description)} // adjust if API field is different
                            value={row[col.field] || ""}
                            onChange={(event, newValue) =>
                              handleInputChange(index, col.field, newValue)
                            }
                            loading={loadingRemarks}
                            sx={{ flex: 1 }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select remark"
                                variant="outlined"
                                sx={{
                                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                  "& .MuiInputBase-input": { padding: "4px" },
                                }}
                              />
                            )}
                          />

                          {/* Add icon outside autocomplete */}
                          <Tooltip title="Add New Remark">
                            <IconButton onClick={handleOpenAddRemark} size="small" sx={{ ml: 1 }}>
                              <AddCircleOutlineIcon color="secondary" />
                            </IconButton>
                          </Tooltip>
                        </Box>


                      ) : col.editable ? (
                        <TextField
                          size="small"
                          type={col.type || "text"}
                          value={row[col.field]}
                          onChange={(e) => handleInputChange(index, col.field, e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                            "& .MuiInputBase-input": { padding: "4px", textAlign: col.align },
                          }}
                          inputProps={col.min !== undefined ? { min: col.min } : {}}
                          fullWidth
                        />
                      ) : (
                        <Typography>{row[col.field]}</Typography>
                      )}
                    </TableCell>
                  ))}


                  {/* Status Icons */}
                  <TableCell align="center">
                    {row.status === "approved" ? (
                      <CheckCircleOutlineIcon sx={{ fontSize: "14px" }} />
                    ) : row.status === "wip" ? (
                      <CheckCircleOutlineIcon sx={{ fontSize: "14px" }} />
                    ) : row.status === "rejected" ? (
                      <Tooltip title="This reel was rejected by user">
                        <CancelIcon sx={{ fontSize: "14px" }} />
                      </Tooltip>
                    ) : row.status === "fg" ? (
                      <Tooltip title="Finished Goods">
                        <CheckCircleIcon sx={{ color: "green", fontSize: "14px" }} />
                      </Tooltip>
                    ) : row.status === "converted" ? (
                      <Tooltip title="Converted to sheet process">
                        <CheckCircleIcon sx={{ color: "green", fontSize: "14px" }} />
                      </Tooltip>
                    ) : (
                      <PendingIcon />
                    )}

                  </TableCell>

                  {/* Action Buttons */}
                  <TableCell align="center">
                    {["approved", "wip"].includes(row.approved_status) && (
                      <Tooltip title="Reverse Approval">
                        <Button size='small' variant='contained' sx={{ backgroundColor: colors.blueAccent[500], textTransform: 'none', fontSize: '8px' }} onClick={() => callReverseApproval(row.cr_number)}>Reverse Approval</Button>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CustomTableContainer>
      {openAddRemark && (
        <>
          <AddRemarks open={openAddRemark} handleClose={handleCloseAddRemark} moduleName={"Winder Machine Production"} parentModuleName={"Production"} userPermissions={userPermissions} />
        </>
      )}

    </div>
  );
};

export default ViewChildReelTable;

